"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAIN_BANNERS = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("swiper/react");
//@ts-ignore
var swr_hooks_1 = require("@l2p/swr-hooks");
var swiper_1 = require("swiper");
var Banners_1 = require("./Banners");
var Games_1 = require("./Banners/Games");
var Tournaments_1 = require("./Banners/Tournaments");
require("./styles.scss");
var MAIN_BANNERS;
(function (MAIN_BANNERS) {
    MAIN_BANNERS["WELCOME"] = "welcome";
    MAIN_BANNERS["GAMES"] = "games";
    MAIN_BANNERS["TOURNAMENTS"] = "tournaments";
    MAIN_BANNERS["PROMOTIONS"] = "promotions";
})(MAIN_BANNERS = exports.MAIN_BANNERS || (exports.MAIN_BANNERS = {}));
var MainSlider = function (_a) {
    var banners = _a.banners, welcomePromo = _a.welcomePromo, welcomeFields = _a.welcomeFields, _b = _a.gameCardPlaceholder, gameCardPlaceholder = _b === void 0 ? '' : _b, _c = _a.isFlex, isFlex = _c === void 0 ? false : _c;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var filteredBanners = (0, react_1.useMemo)(function () {
        return banners.filter(function (banner) {
            if (banner === MAIN_BANNERS.WELCOME)
                return !isAuth;
            if (banner === MAIN_BANNERS.PROMOTIONS)
                return isAuth;
            return true;
        });
    }, [isAuth, banners]);
    return (react_1.default.createElement("div", { className: "slideWrapper" },
        react_1.default.createElement(react_2.Swiper, { modules: [swiper_1.Navigation, swiper_1.Pagination, swiper_1.Autoplay], slidesPerView: 1, navigation: true, pagination: { clickable: true }, lazy: true, preloadImages: false, 
            // autoplay={{
            //   disableOnInteraction: false,
            //   delay: 5000,
            //   pauseOnMouseEnter: true,
            // }}
            autoplay: false }, filteredBanners.map(function (banner, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "".concat(banner).concat(idx) },
            react_1.default.createElement(react_1.default.Fragment, null,
                banner === MAIN_BANNERS.WELCOME ? (react_1.default.createElement(Banners_1.Welcome, { promo: welcomePromo, welcomeFields: welcomeFields, isFlex: isFlex })) : null,
                banner === MAIN_BANNERS.GAMES && (react_1.default.createElement(Games_1.Games, { gameCardPlaceholder: gameCardPlaceholder })),
                banner === MAIN_BANNERS.TOURNAMENTS && react_1.default.createElement(Tournaments_1.Tournaments, null),
                banner === MAIN_BANNERS.PROMOTIONS ? react_1.default.createElement(Banners_1.Promotions, null) : null))); }))));
};
exports.default = MainSlider;
